import {useAuth} from "context/AuthContext";
import {useNavigate} from "react-router-dom";
import {AddMethodModal} from "./addMethod";
import CryptoJS from "crypto-js";
import styled from "styled-components";
import {fonts, themeColor} from "ui/theme";
import {useEffect, useMemo, useState} from "react";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {ButtonPrimary} from "ui/base/Button/ButtonStyled";
import {deleteTeacherPayoutMethods, setDefaultPayoutMethod} from "api";
import {useToast} from "hooks/index.js";
import {PayoutMethodItem} from "./PayoutmethodItem";
import {hideScrollBar} from "../../../../../ui/base/scrollbarStyle/scrollbarStyle";

const UNABLE_TO_CHANGE_DEFAULT_LENGTH = 1

export const PayoutMethod = () => {
    const navigate = useNavigate();
    const {userData} = useAuth();

    const queryClient = useQueryClient()
    const [loading, setLoading] = useState(false);

    const [payoutInfo, setPayoutInfo] = useState(userData?.teacher?.payment_info)
    const [defaultIndex, setDefaultIndex] = useState(null)
    
    const isChangeedDefault = useMemo(() => {
        const index = payoutInfo?.findIndex(it => it.default)
        return defaultIndex !== index
    }, [payoutInfo, defaultIndex])

    const onClick = (item) => {
        const t = payoutInfo.map((method) => {
            if (
                method.first_name === item.first_name &&
                method.last_name === item.last_name &&
                method.stripe_account === item.stripe_account
            ) {
                return {
                    ...method,
                    default: true,
                };
            }
            return {
                ...method,
                default: false,
            };
        });

        setPayoutInfo(t)
    }

    const {mutate: setDefaultMethod} = useMutation({
        mutationFn: setDefaultPayoutMethod,
        onError: (err) => {
            setLoading(false);
            useToast("error", "Update Payout error");
        },
        onSuccess: (data) => {
            useToast("success", "Changes saved");
            setLoading(false);
            queryClient.invalidateQueries(["userDetail"]);
        },
    });

    const {mutate: deletePayoutMethod} = useMutation({
        mutationFn: deleteTeacherPayoutMethods,
        onError: (err) => {
            setLoading(false);
            useToast("error", "Delete Payout error");
        },
        onSuccess: (data) => {
            useToast("success", "Payout Method deleted");
            setLoading(false);
            queryClient.invalidateQueries(["userDetail"]);
        },
    });

    useEffect(() => {
        const index = userData?.teacher?.payment_info?.findIndex(it => it.default)

        setPayoutInfo(userData?.teacher?.payment_info)
        setDefaultIndex(index)
    }, [userData])

    

    const submit = () => {

        setLoading(true)

        const selectedPaymentMethod = payoutInfo.find(it => it.default);


        const payload = {
            stripe_account: selectedPaymentMethod?.stripe_account,
        };

        setDefaultMethod(payload)

    }

    const handleOnDelete = (stripeAccount) => {
        deletePayoutMethod(stripeAccount)
    }

    const handleOnEdit = () => {
        //TODO
    }

    return (
        <Container>

            <Title>{"Your Payout Method"}</Title>

            <SubTitle>{"Select the bank account where you'll receive payments after the class."}</SubTitle>
            <PayoutMethodContainer>
                {payoutInfo?.map((method, indx) => {

                        const bank_account_first_name = CryptoJS.AES.decrypt(method?.first_name, userData?.email)?.toString(CryptoJS.enc.Utf8);

                        const bank_account_last_name = CryptoJS.AES.decrypt(method?.last_name, userData?.email)?.toString(CryptoJS.enc.Utf8);

                        const bank_acccount_info = CryptoJS.AES.decrypt(method?.account_number, userData?.email)?.toString(CryptoJS.enc.Utf8);

                        return (
                            <PayoutMethodItem
                                key={`p_m_${indx}`}
                                method={method}
                                onClick={onClick}
                                onEdit={handleOnEdit}
                                onDelete={handleOnDelete}
                                bank_account_first_name={bank_account_first_name}
                                bank_account_last_name={bank_account_last_name}
                                bank_acccount_info={bank_acccount_info}
                            />
                        )
                    }
                )}
            </PayoutMethodContainer>

            <AddMethodModal/>

            <ButtonPrimary disabled={loading || payoutInfo?.length <= UNABLE_TO_CHANGE_DEFAULT_LENGTH || !isChangeedDefault} onClick={submit}>
                Save Changes
            </ButtonPrimary>
        </Container>
    )
}

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    font-family: var(--font-secondary);
    padding: 1rem;
    max-width: 900px;
    margin-inline: auto;
    gap: 1rem;
    ${hideScrollBar}
`
const Title = styled.h3`
    font-weight: 600;
    font-size: ${fonts.sizes.h5};

    margin-bottom: 1rem;
`;

const SubTitle = styled.p`
    font-weight: 400;
    font-size: ${fonts.sizes.regular};
    color: ${themeColor("placeholder")};
    margin-bottom: 1rem;
`;


const PayoutMethodContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`
